<template>
	<div class="signBox">
		<!--头部-->
		<XDheader></XDheader>
		<div class="container">
			<img
				src="https://scdn.xidong360.com/longhu-marathon/2019/0816/menu/banner.png"
				alt
				style="margin-bottom:10px;"
			/>
			<h5>当前位置/{{menuname?menuname:this.$route.params.key}}</h5>
			<!--内容-->
			<div class="row">
				<div class="col-md-8">
					<div class="content_title">
						<span class="themes_menu_wrap_1">{{menuname?menuname:this.$route.params.key}}</span>
					</div>
					<div class="content_form">
						<ul>
							<li
								data-toggle="modal"
								v-show="i<=8"
								data-target="#myModal"
								v-for="(item,i) in pageimages"
								@click="preview(item)"
								:key="i"
							>
								<img :src="item" alt />
							</li>
						</ul>
						<el-pagination
							v-show="imglist.length>pagesize"
							background
							layout="prev, pager, next"
							:current-page="currentpage"
							:page-size="pagesize"
							:total="imglist.length"
							@current-change="changepage"
							@prev-click="prev"
							@next-click="next"
						></el-pagination>
					</div>
				</div>
				<div class="col-md-4">
					<XDright></XDright>
				</div>
			</div>
		</div>
		<!-- 模态框 -->
		<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
			<div class="modal-dialog" role="document" style="max-width:600px;">
				<div class="modal-content">
					<div class="modal-header" style="border:0;">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding-top: 0;">
						<img :src="src" alt />
					</div>
				</div>
			</div>
		</div>
		<!--底部-->
		<XDfooter></XDfooter>
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
	name: "signquery",
	data() {
		return {
			pagesize: 9,
			currentpage: 1,
			imglist: [],
			src: "",
			pageimages: []
		};
	},
	mounted() {
		this.getimages();
	},
	watch: {},
	methods: {
		getimages() {
			if (this.$route.params.gameId) {
				const { gameId } = this.$route.params;
				api.getimages({ gameId }).then(({ data }) => {
					// console.log(data);
					if (data.code == 0) {
						this.imglist = data.data;
						this.getpageimages();
					}
				});
			}
		},
		getpageimages() {
			var currentpage = this.currentpage;
			var totalpage =
				this.imglist.length % this.pagesize == 0
					? this.imglist.length / this.pagesize
					: Math.floor(this.imglist.length / this.pagesize) + 1;
			var pageimages = [];
			for (
				var i = (currentpage - 1) * this.pagesize;
				i < this.imglist.length;
				i++
			) {
				pageimages.push(this.imglist[i]);
				if (pageimages.length == this.pagesize) break;
			}
			this.pageimages = pageimages;
		},
		preview(i) {
			this.src = i;
		},
		changepage(i) {
			if (i == this.currentpage) return;
			this.currentpage = i;
			this.getpageimages();
		},
		prev(i) {
			this.currentpage = i;
			this.getpageimages();
		},
		next(i) {
			this.currentpage = i;
			this.getpageimages();
		}
	},
	computed: {
		...mapState(["gameId", "menuname"])
	}
};
</script>
<style scoped>
img {
	width: 100%;
}
.content_title {
	text-indent: 0;
	background-color: #ebebeb;
	height: 60px;
	padding: 0;
	margin-bottom: 30px;
}
h5 {
	margin-bottom: 30px;
}
.content_title span {
	line-height: 60px;
	display: inline-block;
	height: 100%;
	box-shadow: none;
	padding: 0 30px;
}
.content_form {
	text-align: center;
}
.content_form ul {
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
	padding-left: 0;
}
.content_form li {
	width: 32%;
	margin-right: 2%;
	margin-bottom: 20px;
}
.content_form li img {
	width: 100%;
	max-height: 170px;
}
.content_form li:nth-of-type(3n) {
	margin-right: 0;
}
.content_form span {
	font-size: 12px;
	border: 1px solid #ddd;
	background: #fff;
	padding: 5px 15px;
	border-radius: 20px;
	color: #999;
	cursor: pointer;
}
.content_form span:hover {
	border-color: #409eff;
	color: #409eff;
}
.content_form span:active {
	border-color: #ddd;
}

.el-pagination button,.el-pagination .el-pager li.number{
    box-sizing: border-box;
    text-indent: 0;
}
.content_form ul li{
    text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/template/pageContent/pics.vue